import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { PHONE_VERIFICATION_ACTION_TYPE, PhoneVerificationAction } from "./phone-verification.action";
import { PHONE_VERIFICATION_MESSAGE_CODES } from "./phone-verification.const";
import { PhoneVerificationService } from "./phone-verification.service";

/**
 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
 */
@Injectable()
export class PhoneVerificationEffect {
	/**
	 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
	 */
	requestSmsCode$ = createEffect(() =>
		this.actions$.pipe(
			ofType(PHONE_VERIFICATION_ACTION_TYPE.requestCode),
			map((x: ActionWithPayload<string>) => x.payload),
			switchMap((phoneNumber: string) =>
				this.service.requestCode(phoneNumber).pipe(
					map(() => this.action.requestCodeSuccess()),
					catchError((response: AppError) => of(this.action.requestCodeFail(response)))
				)
			)
		)
	);

	/**
	 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
	 */
	verify$ = createEffect(() =>
		this.actions$.pipe(
			ofType(PHONE_VERIFICATION_ACTION_TYPE.verifyCode),
			map((x: ActionWithPayload<number>) => x.payload),
			switchMap((smsCode) =>
				this.service.verifyCode(smsCode).pipe(
					map(() => this.action.verifyCodeSuccess()),
					catchError((response: AppError) => of(this.action.verifyCodeFail(response)))
				)
			)
		)
	);

	/**
	 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
	 */
	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[PHONE_VERIFICATION_ACTION_TYPE.requestCodeFail]: PHONE_VERIFICATION_ACTION_TYPE.requestCode,
				[PHONE_VERIFICATION_ACTION_TYPE.verifyCodeFail]: PHONE_VERIFICATION_ACTION_TYPE.verifyCode,
			}),
			this.messageService.mapClearByContext$({
				[PHONE_VERIFICATION_ACTION_TYPE.requestCode]: PHONE_VERIFICATION_ACTION_TYPE.requestCode,
				[PHONE_VERIFICATION_ACTION_TYPE.verifyCode]: PHONE_VERIFICATION_ACTION_TYPE.verifyCode,
			}),
			this.messageService.map$({
				[PHONE_VERIFICATION_ACTION_TYPE.requestCodeSuccess]: {
					context: PHONE_VERIFICATION_ACTION_TYPE.requestCodeSuccess,
					scope: MessageScopeType.Local,
					type: MessageType.Success,
					messageCode: PHONE_VERIFICATION_MESSAGE_CODES.success.requestCodeSuccess,
				},
				[PHONE_VERIFICATION_ACTION_TYPE.verifyCodeSuccess]: {
					context: PHONE_VERIFICATION_ACTION_TYPE.verifyCodeSuccess,
					scope: MessageScopeType.Local,
					type: MessageType.Success,
					messageCode: PHONE_VERIFICATION_MESSAGE_CODES.success.verifyCodeSuccess,
				},
			})
		)
	);

	constructor(
		private actions$: Actions,
		private action: PhoneVerificationAction,
		private service: PhoneVerificationService,
		private messageService: MessageService
	) {}
}
